import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  root: {
    padding: theme.spacing(2),
  },
  titleSection: {},
  title: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 700,
    color: theme.palette.common.normalTitle,
  },
  description: {
    marginTop: theme.spacing(1),
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.common.normalTitle,
  },
  subTitleSection: {
    display: "flex",
    flexDirection: "row",
    marginBottom: theme.spacing(1),
  },
  subTitle: {
    display: "flex",
    alignItems: "center",
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 700,
    color: theme.palette.common.normalTitle,
  },
  subTitleIcon: {
    marginRight: theme.spacing(0.5),
  },
  subSectionContent: {
    display: "flex",
    flexDirection: "row",
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  detailsSection: {
    width: "100%",
    padding: 0,
    color: theme.palette.common.normalTitle,
  },
  workingDayListItem: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  sectionText2: {
    textAlign: "right",
    fontWeight: "bold",
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.common.normalTitle,
  },
  notAvailable: {
    color: theme.palette.common.red,
  },
  bodySection: {
    marginTop: theme.spacing(1),
  },
  closeButton: {
    boxSizing: "border-box",
    zIndex: 100,
    position: "absolute",
    padding: theme.spacing(0.4),
    top: theme.spacing(1),
    right: theme.spacing(3.2),
    width: 32,
    height: 32,
    borderRadius: "50%",
    color: theme.palette.primary.main,
    // backgroundColor: theme.palette.common.white
  },
  cuisinesItem: {
    display: "flex",
    flexDirection: "row",
  },
  cuisinesItemImage: {
    width: "60px",
    height: "60px",
    marginRight: theme.spacing(1),
  },
  cuisinesItemText: {
    marginBottom: theme.spacing(0),
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.common.normalTitle,
    display: "flex",
    alignItems: "center",
  },
  versionCon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "1rem",
  },
  textDimmed: {
    fontSize: theme.typography.pxToRem(12),
    color: "#6a6a6a",
  },
  footerDiv: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  footerLinkText: {
    marginRight: "10px",
    textDecoration: "none",
    fontSize: theme.typography.pxToRem(14),
    "&:hover": {
      textDecoration: "none",
      cursor: "pointer",
    },
  },
}));

export default useStyles;
